import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontDisplay, fontText, hexToRgbA, isMobileApp, StylesIndexInjections } from 'common-react';
import { fieldBoxShadow, focusStyle } from '../styles/mixins';

const mobileBottomPadding = 16;
const getMobileBottomPadding = (theme: Theme) => mobileBottomPadding + theme.space.mobileBottomPadding();

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    color: theme.color.greys[80],
    border: 0,
    padding: 0,
    margin: 0,
    font: fontDisplay('normal', theme.fontSize.s, 16),
    '&.MuiInput-underline:after': {
      display: 'none'
    },
    '&.MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-inputSelect': {
      marginLeft: 5,
      paddingRight: 8,
    },
    '&.MuiOutlinedInput-root': {
      '& .MuiSelect-icon': {
        right: 24,
        '& path': {
          fill: 'none',
        }
      }
    },
    '& .MuiSelect-select': {
      paddingRight: 0,
      minWidth: 'calc(100% + 10px)',
      '&:focus': {
        backgroundColor: 'transparent',
      },
      '&:focus-visible': {
        ...focusStyle(theme),
      },
      '&.MuiSelect-outlined': {
        backgroundColor: theme.color.greys[0],
        padding: '16px 58px 16px 16px',
        minWidth: 'unset',
        border: `1px solid ${theme.color.greys[40]}`,
        borderRadius: 8,
        '&:focus': {
          backgroundColor: theme.color.greys[0],
        },
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    }
  },
  icon: {
    top: 'calc(50% - 10px)',
    right: -16,
    '& path': {
      fill: theme.color.greys[80]
    }
  },
  popover: {
    border: `1px solid ${theme.color.greys[15]}`,
    marginTop: 6,
    borderRadius: 16,
    backgroundColor: theme.color.greys[0],
    boxShadow: fieldBoxShadow(theme).bs3,
  },
  select: {
    display: 'flex',
    alignItems: 'center',
  },
  selectTriggerText: {
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.color.greys[80],
    font: fontText('normal', theme.fontSize.base, 24),
    letterSpacing: '-0.02em',
  },
  menuList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 10,
    padding: '12px 8px 8px 8px',
    outline: 'none',
  },
  menuListMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: 0,
    width: '100%',
    outline: 'none',
  },
  menuItem: {
    padding: 0,
    minHeight: 'unset',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focusVisible': {
      ...focusStyle(theme, -2),
      backgroundColor: 'transparent',
    },

    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      }
    },

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      width: '100%',
      borderTop: `1px solid ${theme.color.greys[15]}`,
      '&:first-child': {
        borderTop: 0,
      },
    },
  },
  menuItemContent: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: 10,
    padding: 8,
    borderRadius: 8,
    color: theme.color.greys[80],
    '&:hover': {
      backgroundColor: hexToRgbA(theme.color.greys[80], 0.08),
    },

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      padding: '12px 0',
    }
  },

  dialog: {
    '& .MuiPaper-root': {
      marginBottom: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      top: 'unset',
      width: '100%',
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      maxWidth: '100%',
      '& > div': {
        [theme.breakpoints.down('sm')]: {
          margin: 0,
          padding: 16,
          paddingBottom: isMobileApp() ? getMobileBottomPadding(theme) : mobileBottomPadding,
        },
      }
    },
    '& .MuiDialogContent-root > div': {
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
  },
  dialogCard: {
    paddingTop: 40,
    paddingBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },

}), { name: 'Select', index: StylesIndexInjections.OTHER });
